
module.exports =  require('./lib/');



/*****************
 ** WEBPACK FOOTER
 ** ./~/engine.io-client/index.js
 ** module id = 697
 ** module chunks = 0
 **/